import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  api: string = `${environment.url}/certificate`

  constructor(private http: HttpClient) { }

  post(file: File, password: string, partnerId: string) {
    const headers = new HttpHeaders()
    headers.append('Content-Type', 'multipart/form-data');

    const formData = new FormData();
    formData.append('file', file)
    formData.append('password', password)
    formData.append('partnerId', partnerId)

    // console.log('file', file)
    // console.log('password', password)
    // console.log('partnerId', partnerId)

    // console.log('formData: ', formData)

    return this.http.post(
      `${this.api}`, formData, { headers: headers }
    ) as Observable<any>;

  }


}
